import { render, staticRenderFns } from "./ContinuousFilingMessages.vue?vue&type=template&id=536caaa3&scoped=true&"
import script from "./ContinuousFilingMessages.vue?vue&type=script&lang=js&"
export * from "./ContinuousFilingMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536caaa3",
  null
  
)

export default component.exports